export default __webpack_public_path__ + "static/media/test1.ea8dd1cd.png";